// Base functions
document.addEventListener("DOMContentLoaded", function() {
    document.body.classList.remove('no-js');
    document.body.classList.add('loaded');
});

const initLazyImages = () => {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.onload = () => img.classList.add('loaded');
          delete img.dataset.src;
        }
        observer.unobserve(img);
      }
    });
  }, {
    rootMargin: '50px 0px'
  });

  // Handle eager-loading images immediately
  document.querySelectorAll('img.lazy[loading="eager"]').forEach(img => {
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.onload = () => img.classList.add('loaded');
      delete img.dataset.src;
    }
  });

  // Observe lazy-loading images
  document.querySelectorAll('img.lazy:not([loading="eager"])').forEach(img => {
    imageObserver.observe(img);
  });
};

document.addEventListener('DOMContentLoaded', initLazyImages);
window.refreshLazyImages = initLazyImages;

// Listen for Shopify theme editor changes
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initLazyImages);
}

// Mobile nav show/hide + header scroll
document.addEventListener('DOMContentLoaded', function() {
    const navMenu = document.getElementById('mobile-nav');
    const header = document.querySelector('.header');
    const navToggles = document.querySelectorAll('[nav-toggle]');
    const closeButton = navMenu.querySelector('.close-button');

    function closeNav() {
        navToggles.forEach(toggle => toggle.setAttribute('aria-expanded', 'false'));
        navMenu.classList.remove('nav--visible');
        document.body.classList.remove('menu-open');
    }

    function openNav() {
        navToggles.forEach(toggle => toggle.setAttribute('aria-expanded', 'true')); 
        navMenu.classList.add('nav--visible');
        document.body.classList.add('menu-open');
    }

    // Handle nav toggle clicks
    navToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            isExpanded ? closeNav() : openNav();
        });
    });

    // Close nav when clicking close button
    closeButton.addEventListener('click', closeNav);

    // Close nav when clicking outside
    document.addEventListener('click', (e) => {
        const isClickOutside = !navMenu.contains(e.target) && 
                             !Array.from(navToggles).some(toggle => toggle.contains(e.target));
        
        if (isClickOutside && navMenu.classList.contains('nav--visible')) {
            closeNav();
        }
    });

});

// Animation on scroll
function initAnimations() {
  const animatedElements = document.querySelectorAll('.animate');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  animatedElements.forEach(element => {
    observer.observe(element);
  });
}

// Call the function when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', initAnimations);


// Detect if scrolling up or down
(function() {
  let lastScrollTop = 0;
  const body = document.body;
  const scrollThreshold = 5;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (Math.abs(lastScrollTop - scrollTop) <= scrollThreshold) return;

    if (scrollTop > lastScrollTop && scrollTop > 0) {
      body.classList.remove('is-scrolling-up');
      body.classList.add('is-scrolling-down');
    } else {
      body.classList.remove('is-scrolling-down');
      body.classList.add('is-scrolling-up');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('load', () => body.classList.add('is-scrolling-up'));

  handleScroll();
})();


// Enhanced Quick Add to Cart
function handleQuickAdd(variantId, button) {
  const originalText = button.textContent;
  
  button.textContent = 'Adding';
  button.disabled = true;

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  })
  .then(response => {
    if (response.ok) {
      // Trigger cart events
      window.dispatchEvent(new CustomEvent('cart:update'));
      window.dispatchEvent(new CustomEvent('cart:open'));
    }
    return response;
  })
  .catch(error => {
    console.error('Quick add error:', error);
  })
  .finally(() => {
    button.textContent = originalText;
    button.disabled = false;
  });
}

// Handle all quick add buttons including cross-sell variants
document.addEventListener('click', async (e) => {
  // Handle data-quick-add buttons
  const quickAddButton = e.target.closest('[data-quick-add]');
  if (quickAddButton) {
    const variantId = quickAddButton.dataset.quickAdd;
    await handleQuickAdd(variantId, quickAddButton);
    return;
  }
  
  // Handle cross-sell add buttons
  const crossSellButton = e.target.closest('.mini-form button[type="button"]');
  if (crossSellButton) {
    const variantId = crossSellButton.getAttribute('data-variant-id');
    if (variantId) {
      await handleQuickAdd(variantId, crossSellButton);
    }
  }
});

// Handle cross-sell variant selection
document.addEventListener('change', (e) => {
  const variantSelect = e.target.closest('.mini-form select');
  if (variantSelect) {
    const addButton = variantSelect.nextElementSibling;
    if (addButton) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      addButton.setAttribute('data-variant-id', variantSelect.value);
      addButton.disabled = selectedOption.disabled;
    }
  }
});